// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pcsb","left":"styles_left__2COld"};